import React from 'react';
// import Svg, { Path } from 'react-native-svg';
// import { colors } from '../../../theme';

const UserIcon = ({ className, size = 17, color = '#343434', style = {} }) => {
  return (
    <svg
      width={size}
      height={size * 1.11}
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ ...style }}
    >
      <path
        d="M12.126 10.8402C13.1714 10.1776 13.9735 9.19355 14.4116 8.03593C14.8496 6.87831 14.9 5.60976 14.555 4.42107C14.2101 3.23238 13.4885 2.18782 12.4988 1.44451C11.5092 0.701195 10.3049 0.299316 9.06714 0.299316C7.82941 0.299316 6.62516 0.701195 5.63549 1.44451C4.64581 2.18782 3.92424 3.23238 3.5793 4.42107C3.23436 5.60976 3.28469 6.87831 3.72275 8.03593C4.1608 9.19355 4.96287 10.1776 6.00834 10.8402C2.47895 11.9158 0.327698 14.941 0.327698 19.1427C0.327698 19.321 0.398535 19.4919 0.524609 19.618C0.650683 19.7441 0.821667 19.8149 0.999962 19.8149H17.1343C17.3126 19.8149 17.4836 19.7441 17.6097 19.618C17.7358 19.4919 17.8066 19.321 17.8066 19.1427C17.8402 14.941 15.689 11.9158 12.126 10.8402ZM4.73106 6.06712C4.73106 5.20287 4.98731 4.35803 5.46746 3.63943C5.94761 2.92083 6.63007 2.36075 7.42853 2.03002C8.22699 1.69929 9.10562 1.61275 9.95326 1.78136C10.8009 1.94996 11.5795 2.36614 12.1906 2.97725C12.8018 3.58837 13.2179 4.36698 13.3865 5.21462C13.5551 6.06227 13.4686 6.94087 13.1379 7.73933C12.8071 8.5378 12.2471 9.22025 11.5285 9.7004C10.8099 10.1806 9.96503 10.4368 9.10078 10.4368C7.94833 10.4161 6.84886 9.9491 6.03382 9.13406C5.21879 8.31902 4.75177 7.21956 4.73106 6.06712ZM1.70587 18.504C1.97478 14.4704 4.73103 11.7814 9.06714 11.7814C13.4032 11.7814 16.1595 14.4704 16.4284 18.504H1.70587Z"
        fill={color}
      />
    </svg>
  );
};

export default UserIcon;
